<template>
  <div class="main">
    <div class="container">
      <ul class="breadcrumb">
        <li>
          您所在的位置：
        </li>
        <li class="alpha hover">
          <a>首页</a>
        </li>
        <li class="alpha hover" @click="$router.push('/')">
          <a>行政处罚信息公开</a>
        </li>
        <li class="active">
          {{ form.penaltyDecisionNo ? '处罚决定书文号' : $route.query.name }}
        </li>
      </ul>
      <div class="box box-default">
        <div class="case-list">
          <div class="well">
            根据《上海市行政处罚案件信息主动公开办法》（沪府令36号），将上海市城市管理行政执法局一般
            程序案件作出的行政处罚决定向社会全面公开。促进上海市城市管理行政执法严格、规范、公正、文明
            ，维护公平竞争的市场秩序，保障公民、法人和其他组织的合法权益。
          </div>
          <h3 class="model-title">
            <span>
              {{
                form.penaltyDecisionNo ? '处罚决定书文号' : $route.query.name
              }}</span
            >
          </h3>
          <ul class="ul-list">
            <li
              v-for="item in list"
              :key="item.guid"
              @click="clickFn(item.guid)"
            >
              <a>
                <span class="time" v-if="!form.penaltyDecisionNo"
                  >[{{
                    item.penaltydate ? item.penaltydate.split(' ')[0] : ''
                  }}]</span
                >
                <span class="time" v-if="form.penaltyDecisionNo"
                  >[{{ item.penaltydecisionno }}]</span
                >
                <span class="phone">{{ item.casename }}</span>
                <span class="adress">{{ item.penaltyorganname }}</span>
              </a>
            </li>
          </ul>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="form.page"
            :page-size="form.limit"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCaseInfoList } from '@/http'
export default {
  data() {
    return {
      list: [],
      total: 0,
      form: {
        page: 1,
        limit: 15,
        tel: '',
        id: '',
      },
    }
  },
  methods: {
    init() {
      getCaseInfoList(this.form).then((res) => {
        this.total = res.total
        this.list = res.list
      })
    },
    clickFn(val) {
      this.$router.push({
        path: '/detail',
        query: {
          guid: val,
        },
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.init()
    },
  },
  mounted() {
    this.form.id = this.$route.query.guid
    this.form.penaltyDecisionNo = this.$route.query.penaltyDecisionNo
    this.init()
  },
}
</script>
<style lang="less">
.main {
  .container {
    width: 1000px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    .breadcrumb {
      background-color: transparent;
      font-size: 14px;
      margin-bottom: 10px;
      padding: 0 8px 10px 0;
      list-style-type: none;

      li + li:before {
        content: '>';
        color: #333;
        padding: 0 5px;
      }

      :nth-child(2):before {
        display: none;
      }

      .hover {
        cursor: pointer;
      }

      li {
        display: inline-block;
      }

      .alpha {
        a {
          color: #333;
        }
      }

      .active {
        color: #777;
      }
    }

    .box {
      border-style: solid;
      border-width: 1px;
      border-color: #d1d1d1;
      margin-bottom: 30px;

      .case-list {
        background-color: #fff;
        padding: 20px 20px 10px 20px;

        .well {
          border-radius: 0;
          line-height: 1.7;
          text-indent: 2em;
          min-height: 20px;
          padding: 19px;
          margin-bottom: 20px;
          background-color: #f5f5f5;
          border: 1px solid #e3e3e3;
          border-radius: 4px;
          //-webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
          //box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
        }

        .model-title {
          font-size: 16px;
          margin: 0 0 20px 0;
          position: relative;
          height: 40px;
          line-height: 40px;
          color: #fff;
        }

        .model-title span {
          position: absolute;
          left: -20px;
          height: 100%;
          width: 214px;
          text-indent: 40px;
          background: url(../../assets/img/title-background.png) right center
            no-repeat;
        }

        .ul-list {
          list-style-type: none;
          padding: 0;
          margin-bottom: 30px;
          min-height: 200px;

          li {
            border-bottom: 1px dashed #d1d1d1;
            padding: 12px 10px 12px 40px;
            background: url(../../assets/img/arrow.png) no-repeat 10px center;
            cursor: pointer;

            a {
              color: #337ab7;
              text-decoration: none;

              .time {
                display: inline-block;
                vertical-align: middle;
                padding-right: 10px;
              }

              .phone {
                display: inline-block;
                vertical-align: middle;
                max-width: 700px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .adress {
                float: right;
              }
            }
          }
        }
      }
    }
  }

  .el-pagination {
    text-align: center;
  }
}
</style>
